import React, { useState } from "react";
import OtpModal from "@/components/common/modal/otp-modal/OtpModal";
import { useDisclosure } from "@mantine/hooks";
import { STEP } from "./types.d";
import { useForm } from "@mantine/form";
import DepositSettlementContainer from "./DepositSettlementContainer";
import {
  useConfirmActionSavingsAccountMutation,
  useInitActionSavingsAccountMutation,
  usePreviewActionSavingsAccountQuery,
} from "@/services/savingsAPI";
import { useLocation } from "react-router-dom";
import { RESULT_CODE } from "@/constants/enum";
import { useGenerateOTPMutation } from "@/services/authAPI";
import { notifications } from "@mantine/notifications";
import { SHA256 } from "crypto-js";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { useTranslation } from "react-i18next";

const DepositSettlementWrapper: React.FC = () => {
  const { t } = useTranslation();
  const [step, setStep] = useState(1);
  const { state } = useLocation();
  const [generateOTP, { isLoading: isLoadingOtp }] = useGenerateOTPMutation();
  const [, actionSavingStore] = useSavingStore();
  const [dataSetThree, setDataSetThree] = useState<
    { key: string; value: string; name: string }[]
  >([]);
  const { data: dataResponse } = usePreviewActionSavingsAccountQuery({
    accountNo: state?.accountNo || "",
    action: "DEPOSIT_SETTLEMENT",
  });
  const dataWithdraw = dataResponse?.body;
  const [sourceLinkId, setSourceLinkId] = useState<string | null>(
    dataWithdraw?.beneficiaryAccounts?.[0]?.accountNo || null,
  );
  const [sourceAvailableBalance, setSourceAvailableBalance] = useState<number>(
    dataWithdraw?.beneficiaryAccounts?.[0]?.availableBalance || 0,
  );
  const [isOpenedOTPModal, { open: openOTPModal, close: closeOTPModal }] =
    useDisclosure(false);
  const [initAction, { isLoading: isLoadingStepOne }] =
    useInitActionSavingsAccountMutation();
  const [confirmActionSavingAccount] = useConfirmActionSavingsAccountMutation();

  const form = useForm({
    initialValues: {
      otp: "",
      otpId: "",
      refId: "",
    },
    validate: {},
    validateInputOnChange: true,
  });

  const handleCloseOtp = () => {
    closeOTPModal();
  };
  const handleStepOne = async () => {
    actionSavingStore.setInfoSavingDeposit(
      dataWithdraw?.savingsAccountInfo || [],
    );
    actionSavingStore.setTransInfoDeposit(dataWithdraw?.transactionInfo || []);
    const res = await initAction({
      accountNo: state?.accountNo || "",
      action: "DEPOSIT_SETTLEMENT",
      beneficiaryAccountNo:
        sourceLinkId || dataWithdraw?.beneficiaryAccounts?.[0]?.accountNo || "",
    }).unwrap();
    if (res.body.resultCode === RESULT_CODE.SUCCESS) {
      form.setFieldValue("refId", res.body.refId);
      setStep(2);
    }
  };

  const handleStepTwo = async () => {
    const otpResponse = await generateOTP({
      otpType: "SMS_OTP",
      objectId: "1234",
      objectType: "tranfer",
      phoneNumber: "0987655679",
    }).unwrap();
    if (otpResponse.body?.resultCode === "0") {
      const resultOTP = otpResponse.body?.otpId;
      // setOtpId(resultOTP);
      form.setFieldValue("otpId", resultOTP);
      openOTPModal();
    }
  };

  const handleConfirmStepTwo = async () => {
    const res = await confirmActionSavingAccount({
      authType: "1",
      otp: SHA256(form.values.otp).toString(),
      otpId: form.values.otpId,
      refId: form.values.refId,
    });
    if (res.data?.body?.resultCode === RESULT_CODE.SUCCESS) {
      setDataSetThree(res.data?.body?.transactionInfo || []);
      setStep(STEP.STEP_3);
    } else {
      notifications.show({
        title: t("ERROR"),
        message: res.data?.body?.resultDesc || "",
        color: "red",
      });
    }
    handleCloseOtp();
  };
  const handleChangeSourceLinkId = (id: string, balance: number) => {
    setSourceLinkId(id);
    setSourceAvailableBalance(balance);
  };
  return (
    <>
      <DepositSettlementContainer
        step={step}
        onChangeSourceLinkId={handleChangeSourceLinkId}
        submitStepOne={handleStepOne}
        submitStepTwo={handleStepTwo}
        onBackStepOne={() => setStep(STEP.STEP_1)}
        dataWithdraw={dataWithdraw}
        isLoadingStepOne={isLoadingStepOne}
        isLoadingOtp={isLoadingOtp}
        dataStepThree={dataSetThree}
      />
      <OtpModal
        opened={isOpenedOTPModal}
        onClose={handleCloseOtp}
        onConfirm={handleConfirmStepTwo}
        expireTime={60}
        otp={form.values.otp}
        onChangeOtp={(value) => form.setFieldValue("otp", value)}
      />
    </>
  );
};

export default DepositSettlementWrapper;
